module.exports = __webpack_public_path__ + "assets/images/StrataLogo_White_Horiz.png";